/**
 * Format a translation string as the site's mono "eyebrow" label.
 *
 * Eyebrows are the small lowercase mono lines above section headings:
 * `say_hello_`, `our_work_`, `manage_`. The
 * trailing-underscore-prompt + word-joining-underscores are a visual
 * aesthetic, not part of the content — translation values in
 * `locales/*.json` carry the natural text ("say hello"), and this
 * helper applies the styling at render time.
 *
 *   toEyebrow("say hello")  // "say_hello_"
 *   toEyebrow("our work")   // "our_work_"
 *   toEyebrow("manage")     // "manage_"
 */
export function toEyebrow(text: string): string {
  return `${text.replace(/\s+/g, "_")}_`;
}
